<template>
  <div>
    <Subheader title="Password Reset" />

    <div class="app-content-column">
      <div class="card">
        <h5>Reset your password</h5>

        <form class="form" @submit.stop.prevent="resetPassword">
          <Field name="password1">
            <input
              v-model="password1"
              type="password"
              placeholder="Password"
              autocomplete="new-password"
              autocorrect="off"
              autocapitalize="none"
            />
          </Field>

          <Field name="password2">
            <input
              v-model="password2"
              type="password"
              placeholder="Confirm Password"
              autocomplete="new-password"
              autocorrect="off"
              autocapitalize="none"
            />
          </Field>

          <div class="button-wrapper is-centered">
            <button type="submit" class="large-button">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/services/users'
import Subheader from '@/components/Subheader'
import Field from '@/components/Field'

export default {
  name: 'PasswordResetConfirm',
  components: {
    Subheader,
    Field,
  },
  data() {
    return {
      password1: '',
      password2: '',
      uid: null,
      token: null,
    }
  },
  created() {
    this.uid = this.$route.params.uid
    this.token = this.$route.params.token
  },
  methods: {
    resetPassword() {
      User.api
        .resetPassword(this.password1, this.password2, this.uid, this.token)
        .then(() => {
          this.$Alert.alert({
            type: 'success',
            message: `<h2>Password Reset Successful</h2>`,
            timeout: 3000,
          })
          this.$router.push({ name: 'Login' })
        })
        .catch(() => {
          this.$Alert.alert({
            type: 'error',
            message: `<h2>Error, please try again! If you continue to have issues, email mzingopartners@gmail.com</h2>`,
            timeout: 3000,
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/cards';
@import '../../styles/mixins/buttons';
@import '../../styles/forms';
@import '../../styles/layout';

.card {
  @include card-w-borders();
}
</style>
